module.exports = __webpack_public_path__ + "img/close-icon.fdafa71a.svg";